import { createContext, useContext, useState, useEffect } from 'react';
import { loginUsuario, registrarUsuario } from '../services/api';

const AuthContext = createContext();

export function AuthProvider({ children }) {
  const [user,    setUser]    = useState(null);
  const [token,   setToken]   = useState(null);
  const [loading, setLoading] = useState(true);
  const [error,   setError]   = useState(null);

  useEffect(() => {
    const savedUser  = localStorage.getItem('turival_user');
    const savedToken = localStorage.getItem('turival_token');
    if (savedUser && savedToken) {
      setUser(JSON.parse(savedUser));
      setToken(savedToken);
    }
    setLoading(false);
  }, []);

  const login = async (email, password) => {
    setError(null);
    try {
      const data = await loginUsuario(email, password);
      if (data.error) {
        setError(data.error);
        return { ok: false };
      }
      setUser(data.usuario);
      setToken(data.token);
      localStorage.setItem('turival_user',  JSON.stringify(data.usuario));
      localStorage.setItem('turival_token', data.token);
      return { ok: true, rol: data.usuario.rol || 'capitan' };
    } catch {
      setError('Error de conexión con el servidor');
      return { ok: false };
    }
  };

  // Login desde OAuth Google — recibe usuario y token directamente
  const loginConToken = (usuario, token) => {
    setUser(usuario);
    setToken(token);
    localStorage.setItem('turival_user',  JSON.stringify(usuario));
    localStorage.setItem('turival_token', token);
  };

  const registro = async (datos) => {
    setError(null);
    try {
      const data = await registrarUsuario(datos);
      if (data.error) {
        setError(data.error);
        return false;
      }
      setUser(data.usuario);
      setToken(data.token);
      localStorage.setItem('turival_user',  JSON.stringify(data.usuario));
      localStorage.setItem('turival_token', data.token);
      return true;
    } catch (err) {
      setError('Error de conexión con el servidor');
      return false;
    }
  };

  const logout = () => {
    setUser(null);
    setToken(null);
    localStorage.removeItem('turival_user');
    localStorage.removeItem('turival_token');
  };

  return (
    <AuthContext.Provider value={{ user, token, loading, error, login, loginConToken, registro, logout }}>
      {!loading && children}
    </AuthContext.Provider>
  );
}

export function useAuth() {
  return useContext(AuthContext);
}
